"use client";

import Link from "next/link";
import React from "react";

import { useSrcImage } from "@/hooks/useSrcImage";
import type { ImageCardProps } from "./imageCard.types";

import s from "./imageCard.module.scss";

const ImageCard = ({
  id,
  children,
  hasHover = true,
  linkProps = {},
  customStyles = {},
  imageProps = { src: "", alt: "" },
  actions
}: ImageCardProps) => {
  const { srcImage, setImageError } = useSrcImage();

  const { src, alt, fetchPriority = "auto" } = imageProps;
  const { root, image, content } = customStyles;
  const { link, outsideLink } = linkProps;

  const renderImageCardChildComponent = () => (
    <>
      <img
        style={image}
        src={srcImage(src)}
        className={s.image}
        alt={alt}
        fetchPriority={fetchPriority}
        loading="lazy"
        onError={() => setImageError(true)}
      />
      <div style={content} className={s.content} data-has-actions={!!actions}>
        {children}
      </div>
    </>
  );

  return (
    <div id={id} style={root} className={s.wrapper} data-has-hover={hasHover}>
      {link && !outsideLink ? (
        <>
          <Link
            className={s.link}
            href={link}
            role="link"
            style={{ display: "contents" }}
          >
            {renderImageCardChildComponent()}
          </Link>
          {!!actions && actions}
        </>
      ) : link && outsideLink ? (
        <>
          <Link
            className={s.link}
            href={link}
            target="_blank"
            rel="noopener noreferrer"
            role="link"
            style={{ display: "contents" }}
          >
            {renderImageCardChildComponent()}
          </Link>
          {!!actions && actions}
        </>
      ) : (
        <>
          {renderImageCardChildComponent()} {!!actions && actions}
        </>
      )}
    </div>
  );
};

export default ImageCard;
